import React, { useContext, useState } from 'react';
import { message, Form, Input, Select, Button, DatePicker } from 'antd';
import { Context } from '../../../defaults';
import { createSubjects, getInstitutionById } from '../../../actions';
import { schoolYearRegex, studyYearRegex, subjectsRegex } from '../../../common';
import { MaskedInput } from 'antd-mask-input';

export function SubjectsAdd({ institutions, languagesType, setAdded, setActive }) {
  const [form] = Form.useForm();
  const { dictionary, language, setLoading } = useContext(Context);
  const [currentRegExp, setCurrentRegExp] = useState('');
  const [currentInstitute, setCurrentInstitute] = useState('');
  const [studyYear, setStudyYear] = useState();
  const requiredMessage = dictionary?.FillTheField[language];

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  const onSaveSubject = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        createSubjects(values)
          .then(() => {
            setLoading(false);
            setAdded(true);
            setActive('2');
            message.success(dictionary?.SuccessfullyAdded[language], 4);
            form.resetFields();
          })
          .catch(() => {
            message.error(dictionary?.SomethingWentWrong[language], 4);
            setLoading(false);
          });
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.FormValidationFail[language], 4);
      });
  };
  const onChangeInstitute = (e, data) => {
    form.setFieldsValue({ studyYear: null })
    data && data.value &&
      getInstitutionById(data.value).then(({ data }) => {
        setCurrentInstitute(data)
        setCurrentRegExp(subjectsRegex(data.studyYearFrom, data.studyYearTo))
      })
  }

  function rulesForStudyYear(e) {
    if (!!e) {
      const value = e.target.value;
      const years = value.split('/');
      if (years[0] > years[1]) {
        return {
          validateStatus: 'error',
          help: dictionary?.StudyYearFromLessThanTo[language],
        };
      }
      if (
        Number.isInteger(parseInt(years[0])) &&
        Number.isInteger(parseInt(years[1])) &&
        years[1] - years[0] !== 1
      ) {
        return {
          validateStatus: 'error',
          help: dictionary?.StudyYearValidate[language],
        };
      }
      if (!value.match(studyYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
      }
      if (!value) {
        return { validateStatus: 'error', help: requiredMessage };
      } else {
        return { validateStatus: 'success', help: null };
      }
    }
  }


  return (
    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 10 }} layout="horizontal">
      <Form.Item
        name="institutionId"
        label={dictionary?.Institution[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select placeholder={dictionary?.Institution[language]}
          allowClear
          onChange={onChangeInstitute}
          showSearch
          filterOption={(input, option) => {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }}
        >
          {!!institutions &&
            institutions.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item
        label={dictionary?.Name[language]}
        name="name"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: dictionary?.MaxLengthField[language] },
          { max: 100, message: dictionary?.MaxLengthField[language] }
        ]}>
        <Input placeholder={dictionary?.Name[language]} />
      </Form.Item>
      <Form.Item
        label={dictionary?.Description[language]}
        name="description"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: dictionary?.MaxLengthField[language] },
          { max: 100, message: dictionary?.MaxLengthField[language] }
        ]}>
        <Input placeholder={dictionary?.Description[language]} />
      </Form.Item>
      <Form.Item
        name="langId"
        label={dictionary?.Lang[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select placeholder={dictionary?.Lang[language]} allowClear={true}>
          {languagesType &&
            languagesType.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>

      <Form.Item
        label={dictionary?.StudyYear[language]}
        name="studyYear"
        rules={[
          { required: true, message: requiredMessage },
          {
            pattern: currentRegExp,
            message: dictionary?.InvalidStudyYear[language].replace('diapasone', `${currentInstitute.studyYearFrom}-${currentInstitute.studyYearTo}`),
          }

        ]}>
        <Input placeholder={dictionary?.StudyYear[language]} type='number' />
      </Form.Item>
      <Form.Item
        label={dictionary?.YearStudy[language]}
        name="yearOfStudy"
        rules={[
          { required: true, message: requiredMessage },
          { pattern: studyYearRegex, message: 'Формат должен быть по типу ХХ/ХХ ' }
        ]}
        {...rulesForStudyYear(studyYear)}>
        <MaskedInput value={studyYear} onChange={setStudyYear} mask="11/11" placeholder="__/__" />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type="primary" size="large" htmlType="submit" onClick={() => onSaveSubject()}>
          {dictionary?.Add[language]}
        </Button>
      </Form.Item>
    </Form>
  );
}
